import { useConnectedBuyerMembership, useUserBuyerCompanyId } from 'src/contexts/userContext'
import { useBuyerSubscriptionsQuery, useMarketplacesQuery } from 'src/queries/shared'

const useDefaultMarketplaceId = () => {
  const userBuyerCompanyId = useUserBuyerCompanyId()
  const connectedBuyerMembership = useConnectedBuyerMembership()

  const buyerCompanyId = userBuyerCompanyId || connectedBuyerMembership?.buyerCompanyId || undefined

  const { data: marketplaces = [] } = useMarketplacesQuery({
    contextualMembershipId: connectedBuyerMembership?.id,
  })

  const { data: marketplaceId } = useBuyerSubscriptionsQuery({
    queryParams: {
      companyId: buyerCompanyId,
      marketplaceId: marketplaces.map(({ id }) => id),
    },
    queryOptions: {
      enabled: !!buyerCompanyId,
      select: buyerSubscriptions =>
        buyerSubscriptions.find(subscription => subscription.default)?.marketplaceId,
    },
    contextualMembershipId: connectedBuyerMembership?.id,
  })

  return marketplaceId
}

export default useDefaultMarketplaceId
